<template>
  <div id="app">
    <TopNav />
    <router-view />
    <!-- 页脚 -->
    <footer class="site-footer">
      <div class="footer-inner">
        <!-- Google Ads 广告区域 -->
        <div class="google-ads-inner">
          <div class="ads-label">广告</div>
          <ins class="adsbygoogle"
            style="display:block"
            data-ad-client="ca-pub-7936035560253952"
            data-ad-slot="9629797728"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
        </div>
        <p>Copyright © GuoJiaDaiMa.com &nbsp;&nbsp;&nbsp; <a href="https://www.guojiadaima.com/v/000/">历史版本</a> &nbsp;&nbsp;&nbsp; <a href="/m/articles/jiucuo.html" target="_black">网站纠错</a></p>
        <p class="footer-links">
          <span>友情链接：</span>
          <a href="https://rmbdx.com/" target="_blank" rel="noopener">人民币大写转换</a>
          <span class="sep">|</span>
          <a href="https://wheelofnames.cn" target="_blank" rel="noopener">随机转盘</a>
        </p>
        <p class="footer-icp">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">豫ICP备18020969号</a>
          <span class="sep">|</span>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41010502006912" target="_blank" rel="noopener">豫公网安备41010502006912号</a>

        </p>
        <p class="footer-disclaimer">数据来源：ISO 3166-1 国际标准</p>
      </div>
    </footer>
  </div>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: 'App',
  components: { TopNav },
  mounted () {
    // 激活 Google Ads
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch (e) {
      // 广告加载失败时静默处理
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  background: #f5f7fa;
  color: #333;
  line-height: 1.6;
}

a {
  color: #1677ff;
  text-decoration: none;
}
a:hover { color: #4096ff; }

/* Google Ads 区域（位于 footer 内，打印时会随 footer 一起隐藏）*/
.google-ads-inner {
  margin: 0 auto 20px;
  max-width: 800px;
  min-height: 90px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.ads-label {
  text-align: right;
  font-size: 12px;
  color: #999;
  padding: 4px 10px 0;
  line-height: 1.4;
}

.site-footer {
  background: #1a1a2e;
  color: #8899aa;
  padding: 30px 20px;
  text-align: center;
  font-size: 13px;
  margin-top: 40px;
}
.footer-inner p { margin: 6px 0; }
.footer-links a { color: #8899aa; }
.footer-links a:hover { color: #fff; }
.sep { margin: 0 10px; color: #556; }
.footer-icp { font-size: 12px; }
.footer-disclaimer { margin-top: 10px; color: #556; }
</style>
